import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import WebFilters from "./webFilters.tsx";
import MobFilters from "./mobFilters.tsx";
import PopOver from "./popOver.tsx";
import { RootState } from "../../../../../store/store.tsx";

interface FiltersProps {
  setFilterValue: React.Dispatch<React.SetStateAction<string>>;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  setSortByValue: React.Dispatch<React.SetStateAction<string>>;
  setSortByOrder: React.Dispatch<React.SetStateAction<string>>;
  setUpdateSearchValue: React.Dispatch<React.SetStateAction<string>>;
  updateSearchValue: string;
  filterValue: string;
  searchValue: string;
  sortByValue: string;
  sortByOrder: string;
}

const Filters: React.FC<FiltersProps> = ({
  setFilterValue,
  setSearchValue,
  setSortByValue,
  setSortByOrder,
  setUpdateSearchValue,
  updateSearchValue,
  filterValue,
  searchValue,
  sortByValue,
  sortByOrder,
}) => {
  const [anchorE2, setAnchorE2] = useState<null | HTMLElement>(null);
  const [sortAnchor, setSortAnchor] = useState<null | HTMLElement>(null);
  const openFilterOptions = Boolean(anchorE2);
  const openSortOptions = Boolean(sortAnchor);
  const { customStatuses } = useSelector((state: RootState) => state.config);

  const sortOptions = [
    { label: "Date", value: "updated_at" },
    {
      label: "Status",
      value: "status",
    },
  ];

  const sortOrderLabels = [
    { label: "Ascending", value: "asc" },
    {
      label: "Descending",
      value: "desc",
    },
  ];

  useEffect(() => {
    const handler = setTimeout(() => {
      setUpdateSearchValue(searchValue);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue, updateSearchValue]);

  const handleSearchTicket = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (event?.target) {
      setSearchValue(event.target.value);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>, label: string) => {
    if (label === "filters") {
      setAnchorE2(event.currentTarget);
    } else if (label === "sort") {
      setSortAnchor(event.currentTarget);
    }
  };

  const handleFilterChange = (value: string) => {
    if (value) {
      setFilterValue(value);
    }
  };

  const handleSortByChange = (value: string) => {
    if (value) {
      setSortByValue(value);
    }
  };

  const handleSortOrder = (value: string) => {
    if (value) {
      setSortByOrder(value);
    }
  };

  const clearFilter = (value: string) => {
    setFilterValue(value);
    handleClose();
  };

  const clearSort = (value: string) => {
    setSortByValue("updated_at");
    setSortByOrder("desc");
    handleClose();
  };

  const handleClose = () => {
    setAnchorE2(null);
    setSortAnchor(null);
  };

  return (
    <>
      <WebFilters
        handleSearchTicket={handleSearchTicket}
        handleClick={handleClick}
        searchValue={searchValue}
        filterValue={filterValue}
        sortByValue={sortByValue}
        sortByOrder={sortByOrder}
      />
      <MobFilters
        handleSearchTicket={handleSearchTicket}
        handleClick={handleClick}
        searchValue={searchValue}
        filterValue={filterValue}
        sortByValue={sortByValue}
        sortByOrder={sortByOrder}
      />
      {openFilterOptions && (
        <PopOver
          openOptions={openFilterOptions}
          anchorE={anchorE2}
          handleClose={handleClose}
          filterValue={filterValue}
          handleFilterChange={handleFilterChange}
          clearFilter={clearFilter}
          customStatusList={customStatuses}
        />
      )}
      {openSortOptions && (
        <PopOver
          openOptions={openSortOptions}
          anchorE={sortAnchor}
          handleClose={handleClose}
          handleSortByChange={handleSortByChange}
          handleSortOrder={handleSortOrder}
          clearSort={clearSort}
          sortOptions={sortOptions}
          sortOrderLabels={sortOrderLabels}
          style={{ marginLeft: "-10px" }}
          sortByOrder={sortByOrder}
          sortByValue={sortByValue}
        />
      )}
    </>
  );
};

export default Filters;
